<script lang="ts">
	import { Spinner, Text } from '@Shelly/shelly-design-system/index';
	import { format } from 'svelte-i18n';
	import { get } from 'svelte/store';
	export let text: string = '';

	const _format = get(format);
	$: displayText = text || _format('loading_video', { default: 'Loading...' });
</script>

<div
	class="loader d-flex flex-direction-column align-items-center justify-content-center width-full height-full pl-m pr-m text-center"
>
	<Spinner size="m" />
	<Text styleType="body-small" class="text-muted">{displayText}</Text>
</div>

<style>
	.loader {
		position: absolute;
		background: rgba(0, 0, 0, 0.65);
		z-index: 1;
		gap: 12px;
	}
</style>
